<template>
  <span v-if="status">
    <AppChip :color="status.badgeColor" :text-color="status.textColor">
      {{ status.text }}
    </AppChip>
    <div v-if="!hideTimestamp && status.timestamp">
      {{ $dayjs.date(status.timestamp, "fullTime") }}
    </div>
  </span>
</template>
<script>
import { defineComponent, computed } from "vue";
import { useTranslation } from "@/plugins/i18next/i18next";
import gql from "fraql";
import AppChip from "@elements/AppChip.vue";

export default defineComponent({
  name: "AppShowInvoiceStatus",
  components: { AppChip },
  props: {
    invoice: {
      type: Object,
      required: true
    },
    hideTimestamp: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { t } = useTranslation();

    const status = computed(() => {
      switch (props.invoice.status) {
        case "DRAFT":
          return {
            text: t("wallet:invoice.status.DRAFT.label", "draft"),
            badgeColor: "#9B9B9B",
            textColor: "white--text"
          };
        case "OPEN":
          return {
            text: t("wallet:invoice.status.OPEN.label", "open"),
            badgeColor: "#bf581d",
            textColor: "white--text",
            timestamp: props.invoice.issuedAt
          };
        case "PAID":
          return {
            text: t("wallet:invoice.status.PAID.label", "paid"),
            badgeColor: "#A2C037",
            textColor: "white--text",
            timestamp: props.invoice.paidAt
          };
        case "VOIDED":
          return {
            text: t("wallet:invoice.status.VOIDED.label", "voided"),
            badgeColor: "#9B9B9B",
            textColor: "white--text",
            timestamp: props.invoice.voidedAt
          };
        case "UNCOLLECTIBLE":
          return {
            text: t(
              "wallet:invoice.status.UNCOLLECTIBLE.label",
              "uncollectible"
            ),
            badgeColor: "#D0021B",
            textColor: "white--text",
            timestamp: props.invoice.uncollectibleAt
          };
        case "DELETED":
          return {
            text: t("wallet:invoice.status.DELETED.label", "deleted"),
            badgeColor: "#9B9B9B",
            textColor: "white--text"
          };
        default:
          return null;
      }
    });

    return {
      status
    };
  },
  fragments: {
    invoiceFields: gql`
      fragment _ on Invoice {
        status
        issuedAt
        paidAt
        voidedAt
        uncollectibleAt
      }
    `
  }
});
</script>
